import { render, staticRenderFns } from "./TokenDeleteCustom.vue?vue&type=template&id=c89824ae&"
import script from "./TokenDeleteCustom.vue?vue&type=script&lang=js&"
export * from "./TokenDeleteCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports